import { Language } from "@newgenerated/shared/schema";
import { dictToList } from "@utils/dictUtils";
import { getFrontendTranslations } from "@newgenerated/shared/stubs/getFrontendTranslations";
import { assert } from "@utils/assertion";

export async function getGaDesignTranslations(language: Language): Promise<Map<string, string>> {
  const response = await getFrontendTranslations({ frontendProject: "DESIGN", isoCode: language });
  assert(response.kind === "success", `getFrontendTranslations(DESIGN, ${language}) failed: errorCode=${response.kind === "error" ? response.errorCode : "n/a"} errorMessage=${response.kind === "error" ? response.errorMessage : "n/a"}`);
  return new Map(dictToList(response.data.keys.additionalProperties));
}

declare module "@newgenerated/shared/schema" {
  namespace Language {
    function getDir(lang: Language): "ltr" | "rtl";
  }
}

Language.getDir = function (lang: Language): "ltr" | "rtl" {
  switch (lang) {
    case "en":
    case "de":
    case "es":
    case "ru":
    case "zh":
    case "pt":
    case "fr":
      return "ltr";
    case "ar":
      return "rtl";
  }
};
